import * as types from '../types';

export const updateState = state => ({
    type: types.REGISTER_FIRST_UPDATE_STATE,
    payload: state
});

export const resetState = () => ({
    type: types.REGISTER_FIRST_RESET_STATE
});

export const setupUserInfo = (user) => ({
    type: types.REGISTER_FIRST_SETUP_USER,
    payload: user
});
